/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.SoundsSorting.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsSorting.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.word = null;
  this.syllables = [];
  this.doneButton = null;
};

EDC.Games.SoundsSorting.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.SoundsSorting.Scenes.Main.prototype.constructor = EDC.Games.SoundsSorting.Scenes.Main;

const SS = EDC.Games.SoundsSorting.Scenes.Main.prototype;

SS.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

SS.loadIteration = function () {
  this.createWord();
  this.createSyllables();
  this.createButton();
};

SS.createButton = function () {
  const container = this.add.container(1150, 570);
  const button = this.add.sprite(0, 0, 'button-done');
  const text = this.add.sprite(0, 0, 'text-done');
  container.add(button);
  container.add(text);
  container.setSize(button.displayWidth, button.displayHeight);
  this.scaleAnimation(container);
  container.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(container);
  container.on('pointerup', this.checkAnswer.bind(this), this);
  this.doneButton = container;
};

SS.updatedSyllablesArray = function () {
  const updatedArray = [];
  const arrayX = [];
  for (let i = 0; i < this.syllables.length; i++) {
    arrayX.push(this.syllables[i].x);
  }
  arrayX.sort((a, b) => a - b);
  for (let i = 0; i < arrayX.length; i++) {
    for (let j = 0; j < this.syllables.length; j++) {
      if (arrayX[i] === this.syllables[j].x) {
        this.syllables[j].init_X = this.syllables[j].x;
        updatedArray.push(this.syllables[j]);
      }
    }
  }
  return updatedArray;
};

SS.checkAnswer = function () {
  const { answer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration].answer;
  const sequence = [];
  const updatedArray = this.updatedSyllablesArray();
  for (let i = 0; i < updatedArray.length; i++) {
    sequence.push(updatedArray[i].soundKey);
  }
  let count = 0;
  for (let i = 0; i < updatedArray.length; i++) {
    if (answer[i] === sequence[i]) {
      count += 1;
    }
  }
  if (count === updatedArray.length) {
    this.playCorrect();
    this.syllables.map((x) => {
      x.disableInteractive();
    });
    this.word.disableInteractive();
    this.word.scaleAnim.stop();
    this.word.setScale(1);
    this.doneButton.disableInteractive();
    this.doneButton.scaleAnim.stop();
    this.doneButton.setScale(1);
    this.time.delayedCall(2000, this.shrinkAnimation, [], this);
  } else {
    this.playWrong();
    this.wrongAnimation();
  }
};

SS.wrongAnimation = function () {
  this.tweens.add({
    targets: this.syllables.map((container) => {
      container.getAt(0).setTint(0xff0000);
      container.getAt(1).setTint(0xff0000);
      container.getAt(2).setTint(0xff0000);
      return container;
    }),
    x: '-=15',
    duration: 50,
    ease: 'Linear',
    repeat: 8,
    yoyo: true,
    onComplete: this.resetIteration.bind(this),
  });
};

SS.resetIteration = function () {
  this.syllables.map((container) => {
    container.getAt(0).clearTint();
    container.getAt(1).clearTint();
    container.getAt(2).clearTint();
  });
  this.syllables.map((x) => {
    x.destroy();
  });
  this.syllables = [];
  this.createSyllables();
};

SS.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.syllables.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.2',
        scaleY: '+=0.2',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

SS.nextIteration = function () {
  this.syllables.map((x) => {
    x.destroy();
  });
  this.syllables = [];
  this.word.destroy();
  this.word = null;
  this.doneButton.destroy();
  this.doneButton = null;
  this.loadIteration();
};

SS.createSyllables = function () {
  const { syllables } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const font = {
    font: `${this.gameConfig.answerSize} ${this.gameConfig.font}`,
  };
  for (let i = 0; i < syllables.length; i++) {
    const container = this.add.container(1000, 310);
    const panel = this.add.sprite(0, 0, 'syllable-panel');
    const button = this.add.sprite(85, 85, 'syllable-play');
    const text = this.add.text(
      0,
      0,
      this.gameConfig.assets.syllables[syllables[i]].text,
      font,
    ).setOrigin(0.5);
    container.add(panel);
    container.add(button);
    container.add(text);
    container.setSize(panel.displayWidth, panel.displayHeight);
    container.soundKey = syllables[i];
    container.indexPosition = i;
    container.text = this.gameConfig.assets.syllables[syllables[i]].text;
    // this.startShakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.playSyllable.bind(this, container), this);
    this.input.setDraggable(container);
    container.on(
      'drag',
      ((sprite, pointer, x) => {
        sprite.setPosition(x, 310);
      }).bind(this, container),
    );

    container.on('dragstart', this.onDragstart.bind(this, container), this);
    container.on('dragend', this.onDragStop.bind(this, container), this);

    this.syllables.push(container);
  }
  this.adjustPosition(this.syllables);
};

SS.onDragstart = function (dragObj) {
  dragObj.setDepth(1);
  dragObj.scaleAnim = this.tweens.add({
    targets: dragObj,
    scaleX: 1.2,
    scaleY: 1.2,
    duration: 50,
    delay: 100,
    ease: 'Linear',
  });
  this.syllables.splice(this.syllables.indexOf(dragObj), 1);
};

SS.onDragStop = function (dragObj) {
  dragObj.setDepth(0);
  dragObj.scaleAnim.stop();
  dragObj.setScale(1);
  dragObj.x = Math.round(dragObj.x);
  this.syllables.push(dragObj);
  const updatedArray = this.updatedSyllablesArray();
  this.adjustPosition(updatedArray);
};

SS.playSyllable = function (container) {
  if (container.x === container.init_X) {
    const musicArray = this.sound.getAll();
    for (let i = 0; i < musicArray.length; i++) {
      musicArray[i].setVolume(0.1);
    }
    const music = this.sound.add(`syllable-${container.soundKey}`);
    music.play();
    music.once(
      'complete',
      function (music) {
        const musicArray = this.sound.getAll();
        for (let i = 0; i < musicArray.length; i++) {
          musicArray[i].setVolume(1);
        }
        music.destroy();
      },
      this,
    );
  }
};

SS.adjustPosition = function (array) {
  const width = array.length * array[0].displayWidth;
  const startingX = (this.game.config.width - width) / 2 + 230;
  for (let i = 0; i < array.length; i++) {
    const targetX = startingX + (array[0].displayWidth + 90) * i;
    array[i].init_X = targetX;
    this.tweens.add({
      targets: array[i],
      x: targetX,
      duration: 200,
      ease: 'Linear',
    });
  }
};

SS.createWord = function () {
  const container = this.add.container(320, 720);
  const frame = this.add.sprite(0, 0, 'play-frame');
  const questions = this.add.sprite(0, 0, 'question-marks');
  const button = this.add.sprite(0, 0, 'button-play');
  container.add(frame);
  container.add(questions);
  container.add(button);
  container.setSize(frame.displayWidth, frame.displayHeight);
  this.scaleAnimation(container);
  container.setInteractive();
  this.cursorManager.setDefaultDraggableEvents(container);
  container.on('pointerup', this.playWord.bind(this), this);
  this.word = container;
};

SS.scaleAnimation = function (sprite, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite.scaleAnim = this.tweens.add({
    targets: sprite,
    scaleX: 1.1,
    scaleY: 1.1,
    duration: 400,
    ease: 'Linear',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleAnimation.bind(this, sprite, 6000 + Math.floor(Math.random() * 3000)),
  });
};

SS.playWord = function () {
  const { word } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const musicArray = this.sound.getAll();
  for (let i = 0; i < musicArray.length; i++) {
    musicArray[i].setVolume(0.1);
  }
  const music = this.sound.add(`word-${word}`);
  music.play();
  music.once(
    'complete',
    function (music) {
      const musicArray = this.sound.getAll();
      for (let i = 0; i < musicArray.length; i++) {
        musicArray[i].setVolume(1);
      }
      music.destroy();
    },
    this,
  );
};

SS.createTemplateUI = function () {
  let title;
  let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add.sprite(50, 30, 'title').setOrigin(0);
  } else {
    title = this.make.text({
      x: 30,
      y: 30,
      text: this.gameConfig.titleTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.titleSize}`,
        wordWrap: { width: '450' },
        lineSpacing: 10,
        align: 'center',
      },
    });
  }
  if (instructionsImg) {
    instructions = this.add.sprite(675, 700, 'instructions').setOrigin(0);
  } else {
    instructions = this.make.text({
      x: 675,
      y: 700,
      text: this.gameConfig.instructionsTxt,
      origin: { x: 0, y: 0 },
      style: {
        fontFamily: `${this.gameConfig.font}`,
        fontSize: `${this.gameConfig.instructionsSize}`,
        wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
        lineSpacing: 10,
      },
    });
  }
};

export default EDC.Games.SoundsSorting.Scenes.Main;
